function Section({children, className}) {
  return (
    <div className={'bg-white shadow-md p-5 rounded-lg ' + className}>
      {children}
    </div>
  );
}

export default Section;
